import React from "react";

const InputSection = ({
  isPublicPage,
  inputUrl,
  setInputUrl,
  pages,
  selectedPageId,
  handlePageChange,
}) => (
  <div>
    {isPublicPage ? (
      <div>
        <p className="text-gray-600 mb-2 font-semibold">Enter public page URL:</p>
        <input
          type="text"
          placeholder="Enter public page URL"
          value={inputUrl}
          onChange={(e) => setInputUrl(e.target.value)}
          className="border border-gray-300 focus:border-blue-500 focus:ring focus:ring-blue-200 px-4 py-2 rounded-md shadow-sm w-full"
        />
      </div>
    ) : (
      <div>
        <label htmlFor="pageSelector" className="block mb-2 font-bold text-gray-700">
          Select an Admin Page:
        </label>
        <div className="relative">
          <select
            id="pageSelector"
            value={selectedPageId}
            onChange={handlePageChange}
            className="appearance-none border border-gray-300 focus:border-blue-500 focus:ring focus:ring-blue-200 px-4 py-2 rounded-md shadow-sm w-full bg-white"
          >
            <option value="" disabled>
              Choose a Page
            </option>
            {pages.map((page) => (
              <option key={page.id} value={page.id}>
                {page.name}
              </option>
            ))}
          </select>
          <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none">
            <svg
              className="w-5 h-5 text-gray-400"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M19 9l-7 7-7-7"
              />
            </svg>
          </div>
        </div>
      </div>
    )}
  </div>
);

export default InputSection;
